import React, {forwardRef} from "react";
import {Controller} from "react-hook-form";
import {NumericFormat} from "react-number-format";

export const NumericFormatCustom = forwardRef(
    (
        {
            classNameWrapper,
            name,
            placeholder,
            label,
            thousandSeparator,
            fixedDecimalScale,
            decimalScale,
            prefix,
            suffix,
            control,
            rules,
            selectedValue = "floatValue",
            handleChange,
            isAllowed,
            showError = true,
            maxLength,
            disabled,
            dontShowError
        },
        ref,
    ) => {
        return (
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({field, formState: {errors}}) => {
                    const allowFields = {...field};
                    if (allowFields?.onChange) delete allowFields?.onChange;

                    return (
                        <div
                            className={`custom-numeric-format-box ${
                                classNameWrapper ? classNameWrapper : ""
                            }`}
                        >
                            {label && (
                                <p className={`numeric-autocomplete-label`}>
                                    {`${label}${rules?.required ? "*" : ""}`}
                                </p>
                            )}

                            <NumericFormat
                                className={`numeric-format-input ${
                                    errors[field?.name]?.message
                                        ? "numeric-format-input-error"
                                        : ""
                                }`}
                                disabled={disabled}
                                ref={ref}
                                {...allowFields}
                                onValueChange={(formats) => {
                                    const changedFormat = formats[selectedValue];
                                    if (changedFormat === undefined || changedFormat === "") {
                                        handleChange ? handleChange("") : field.onChange("");
                                    } else {
                                        handleChange
                                            ? handleChange(changedFormat)
                                            : field.onChange(changedFormat);
                                    }
                                }}
                                thousandSeparator={thousandSeparator}
                                fixedDecimalScale={fixedDecimalScale}
                                decimalSeparator="."
                                allowNegative={false}
                                maxLength={maxLength}
                                isNumericString
                                isAllowed={isAllowed}
                                prefix={prefix ? prefix : ""}
                                suffix={suffix ? suffix : ""}
                                placeholder={placeholder}
                                decimalScale={decimalScale}
                                focus={true}
                                onBlur={(e) => {
                                    field?.onBlur(e);
                                }}
                            />
                            {showError && (
                                <p className="error-message">{errors[field?.name]?.message}</p>
                            )}
                        </div>
                    );
                }}
            />
        );
    },
);

NumericFormatCustom.displayName = "NumericFormatCustom";
